(function() {
    "use strict";

    var LOADING_DELAY = 0;

    $.App = function(element, options) {
        this.initialize(element, options)
    };

    $.App.api = function(method, uri, data) {
        return $('body').data('App').api(method, uri, data);
    };

    $.App.prototype = {
        services: [],

        initialize: function (element, options) {
            this.element = element;

            this.options = options || $(this.element).data('app') || {};

            this.main = $('#' + this.options.mainId);

            window.Laravel = window.Laravel || {};
            window.Laravel.csrfToken = this.options.csrfToken;
        },

        api: function (method, uri, data) {
            return $.ajax({
                method: method,
                url: '/api/' + uri,
                data: data,
                dataType: 'json',
                headers: {
                    'Authorization': 'Bearer ' + this.options.apiToken
                }
            });
        },

        showLoading: function () {
            var $main = $(this.main),
                $loadingContainer = $main.find('> [data-role="main-loading-container"]'),
                $overlay = $loadingContainer.find('[data-role="overlay"]'),
                $label = $loadingContainer.find('[data-role="label"]'),
                $loading = $loadingContainer.find('[data-loading]');

            clearTimeout($loadingContainer.data('loading-timeout'));

            $loadingContainer.removeClass('hidden');

            $loading.data('loading-timeout', setTimeout(function() {
                $loading.removeClass('hidden');
                $overlay.removeClass('hidden');
                $label.removeClass('hidden');
            }, LOADING_DELAY));
        },

        hideLoading: function () {
            var $main = $(this.main),
                $loadingContainer = $main.find('> [data-role="main-loading-container"]'),
                $overlay = $loadingContainer.find('[data-role="overlay"]'),
                $label = $loadingContainer.find('[data-role="label"]'),
                $loading = $loadingContainer.find('[data-loading]');

            clearTimeout($loadingContainer.data('loading-timeout'));

            $loadingContainer.addClass('hidden');
            $overlay.addClass('hidden');
            $label.addClass('hidden');
            $loading.addClass('hidden');
        }
    };

    $.fn.app = function(options) {
        return this.each(function() {
            var $this = $(this),
                $body = $('body');

            if ($this.is('body')) {
                if (! $this.data('App')) {
                    $.App.instance = new $.App(this, options);
                    $this.data('App', $.App.instance);

                    $body.trigger({type: 'app.ready', app: $.App.instance});
                }
            }

            $body.trigger({type: 'app.init', container: this, app: $.App.instance});
            $body.trigger({type: 'app.initafter', container: this, app: $.App.instance});

            return this;
        })
    };
})();
